import ImageUploadMultiple from '../../src/legacy/ImageUploadMultiple';
export default ImageUploadMultiple;
